module.exports = __webpack_public_path__ + "img/machine_on.17b5298a.gif";